/*
 * Copyright (c) 2021 - Indigen Solutions
 * Authors:
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { keyBy } from "lodash";

export class InsurerApi {
    constructor(api) {
        this._insurers = null;
        this.api = api;
    }

    async getAllInsurers() {
        if (this._insurers) {
            return this._insurers;
        }
        const items = await this.api.get("/insurer");
        this._insurers = keyBy(items._embedded.insurers, i => i.code);
        return this._insurers;
    }
}
